"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToCell = exports.readString = void 0;
const Builder_1 = require("../boc/Builder");
function readBuffer(slice) {
    // Check consistency
    if (slice.remaining % 8 !== 0) {
        throw new Error(`Invalid string length: ${slice.remaining}`);
    }
    if (slice.remainingRefs !== 0 && slice.remainingRefs !== 1) {
        throw new Error(`invalid number of refs: ${slice.remainingRefs}`);
    }
    if (slice.remainingRefs === 1 && (1023 - slice.remaining) > 7) {
        throw new Error(`invalid string length: ${slice.remaining / 8}`);
    }
    // Read string
    let res = slice.readBuffer(slice.remaining / 8);
    // Read tail
    if (slice.remainingRefs === 1) {
        res = Buffer.concat([res, readBuffer(slice.readRef())]);
    }
    return res;
}
function readString(slice) {
    return readBuffer(slice).toString();
}
exports.readString = readString;
function bufferToCell(src) {
    let builder = (0, Builder_1.beginCell)();
    if (src.length > 0) {
        if (src.length > 127) {
            let a = src.slice(0, 127);
            let t = src.slice(127);
            builder = builder.storeBuffer(a);
            builder = builder.storeRef(bufferToCell(t));
        }
        else {
            builder = builder.storeBuffer(src);
        }
    }
    return builder.endCell();
}
function stringToCell(src) {
    return bufferToCell(Buffer.from(src));
}
exports.stringToCell = stringToCell;
